import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DropDownFilterComponent } from './dropdown-filter/dropdown-filter.component'

@NgModule({
    declarations: [
        DropDownFilterComponent
    ],
    imports: [
        CommonModule,
        DropDownsModule
    ],
    exports:[DropDownFilterComponent]
  })
  export class CustomFiltersModule { }